import { ContentfulMarkdown } from '@utils/contentful/ContentfulMarkdown'
import { ITermsAndDescriptions } from '../ConfigurableTermsAndDescriptions'

interface IFullWidthListLayout {
  termsAndDescriptionsList: ITermsAndDescriptions[]
}

const TermsList = ({
  items,
}: {
  items: Array<{ term: string; description: string }>
}) => (
  <ul className="w-full flex flex-col list-disc pl-10 list-outside">
    {items.map(({ term, description }) => (
      <li key={term}>
        <div className="flex flex-row mb-10">
          <p className="text-acai font-semibold min-w-64 mr-4">{term}</p>
          <p className="text-boulder">
            <ContentfulMarkdown>{description}</ContentfulMarkdown>
          </p>
        </div>
      </li>
    ))}
  </ul>
)

export function FullWidthListLayout({
  termsAndDescriptionsList,
}: IFullWidthListLayout) {
  const midPoint = Math.ceil(termsAndDescriptionsList.length / 2)
  const leftColumn = termsAndDescriptionsList.slice(0, midPoint)
  const rightColumn = termsAndDescriptionsList.slice(midPoint)

  return (
    <div className="@container text-2xl">
      <div className="w-full grid grid-cols-1 @6xl:grid-cols-2 @6xl:gap-12">
        <TermsList items={leftColumn} />
        <TermsList items={rightColumn} />
      </div>
    </div>
  )
}
